const my_profile = {
  viewMyClubSeacretProfile: "Ver mi perfil de ClubSeacret", // translated
  verifiedEmail: "Correo electrónico verificado", // translated
  unverifiedEmail: "E-mail no verificado", // translated
  viewMoreDetails: "Ver más detalles", // translated
  createdFrom: "Creado desde", // translated
  createdTo: "Creado hasta", // translated
  selectStatus: "Seleccionar estado...", // translated
  searchByTitle: "Buscar por título...", // translated
  pushNotifications: "Notificaciones Push", // translated 
  pushNotificationsDescription: "Recibir notificaciones del navegador para actualizaciones y eventos importantes.", // translated 
  pushNotificationsNotSupported: "Las notificaciones push no son compatibles con este navegador", // translated 
  pushNotificationsDeniedMessage: "Se denegó el permiso de notificación. Por favor, habilite las notificaciones en la configuración de su navegador para recibir notificaciones push.", // translated 
  pushNotificationsEnabled: "Notificaciones push habilitadas exitosamente", // translated 
  pushNotificationsDisabled: "Notificaciones push deshabilitadas exitosamente", // translated 
  userInformationMissing: "Falta información del usuario", // translated 
  failedToUpdatePushNotifications: "Error al actualizar la configuración de notificaciones push", // translated 
  notificationPermissionDenied: "Se denegó el permiso de notificación. Por favor, habilítelo en la configuración de su navegador.", // translated 
  notificationPermissionRequired: "Se requiere permiso de notificación para habilitar notificaciones push", // translated 
  notSupported: "No compatible", // translated 
  permissionDenied: "Permiso denegado", // translated 
  permissionNotRequested: "Permiso no solicitado", // translated 
  enabled: "Habilitado", // translated 
  disabled: "Deshabilitado", // translated 
};


export default my_profile;
